var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandlIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5521_5205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0037 10.8008V20.8422C17.0037 21.4468 17.7638 21.9029 18.7715 21.9029C19.7792 21.9029 20.5394 21.4468 20.5394 20.8422V10.8008C20.101 11.1155 19.4857 11.2958 18.7715 11.2958C18.0573 11.2958 17.4421 11.1155 17.0037 10.8008Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0535 20.3922V15.3008C11.6151 15.6155 10.9999 15.7958 10.2857 15.7958C9.57146 15.7958 8.95625 15.6155 8.51782 15.3008V20.3922C8.51782 20.9968 9.27799 21.4529 10.2857 21.4529C11.2933 21.4529 12.0535 20.9968 12.0535 20.3922Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21.2129C13 21.8175 13.7602 22.2736 14.7679 22.2736C15.7755 22.2736 16.5357 21.8175 16.5357 21.2129V14C16.0973 14.3147 15.4821 14.495 14.7679 14.495C14.0536 14.495 13.4384 14.3147 13 14V21.2129Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 15.0755C11.262 15.0755 12.0535 14.6006 12.0535 14.0148C12.0535 13.429 11.262 12.9541 10.2857 12.9541C9.30932 12.9541 8.51782 13.429 8.51782 14.0148C8.51782 14.6006 9.30932 15.0755 10.2857 15.0755Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7715 10.1253C19.7479 10.1253 20.5394 9.65044 20.5394 9.06462C20.5394 8.4788 19.7479 8.00391 18.7715 8.00391C17.7952 8.00391 17.0037 8.4788 17.0037 9.06462C17.0037 9.65044 17.7952 10.1253 18.7715 10.1253Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5286 12.9535C15.505 12.9535 16.2965 12.4786 16.2965 11.8927C16.2965 11.3069 15.505 10.832 14.5286 10.832C13.5522 10.832 12.7607 11.3069 12.7607 11.8927C12.7607 12.4786 13.5522 12.9535 14.5286 12.9535Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7985 4.5C8.8151 4.5 7.19995 6.11515 7.19995 8.10145C7.19995 10.0849 8.8151 11.7 10.7985 11.7C12.7848 11.7 14.4 10.0849 14.4 8.10145C14.4 6.11515 12.7848 4.5 10.7985 4.5ZM10.7913 7.81047C11.4383 7.81047 11.9506 8.32288 11.9506 8.9528C11.9506 9.49949 11.5832 9.94633 11.0897 10.0728V10.3962C11.0897 10.5563 10.96 10.6861 10.7998 10.6861C10.6395 10.6861 10.5098 10.5563 10.5098 10.3962V10.0696C10.0116 9.93971 9.64894 9.49825 9.64894 8.96993C9.64894 8.8098 9.77863 8.67996 9.93891 8.67996C10.0992 8.67996 10.2289 8.8098 10.2289 8.96993C10.2289 9.28001 10.4812 9.53218 10.7913 9.53218C11.1186 9.53218 11.3706 9.28001 11.3706 8.96993C11.3706 8.64272 11.1186 8.39041 10.8085 8.39041C10.1615 8.39041 9.64894 7.87801 9.64894 7.24822C9.64894 6.70152 10.0164 6.25475 10.5098 6.12814V5.80488C10.5098 5.64474 10.6395 5.5149 10.7998 5.5149C10.96 5.5149 11.0897 5.64474 11.0897 5.80488V6.1312C11.588 6.26102 11.9506 6.70256 11.9506 7.23109C11.9506 7.39123 11.8209 7.52106 11.6606 7.52106C11.5003 7.52106 11.3706 7.39123 11.3706 7.23109C11.3706 6.92101 11.1186 6.6687 10.8085 6.6687C10.4812 6.6687 10.2289 6.92101 10.2289 7.23109C10.2289 7.5583 10.4812 7.81047 10.7913 7.81047Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5521_5205",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8,
    height: 19.8,
    fill: "#ffffff",
    transform: "translate(1.80005 2.7002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandlIconLight);
export default __webpack_public_path__ + "static/media/PANDLIconLight.3d337ddc4cd625e68c2f9244a87964ed.svg";
export { ForwardRef as ReactComponent };